import { jsonMember, jsonObject } from 'typedjson';
import { CollectionSortOrder } from '../enums/collection-sort-order';

@jsonObject
export class CollectionSortRequest {
  @jsonMember(String) public readonly property!: string;
  @jsonMember(String) public readonly order!: CollectionSortOrder;

  public constructor(property: string, order: CollectionSortOrder) {
    this.property = property;
    this.order = order;
  }
}
